import overlayScrollbars from 'overlayscrollbars';

document.addEventListener('turbolinks:load', function () {
  window.dispatchEvent(new Event('resize'));

  // Apply custom scrollbar
  overlayScrollbars(document.querySelectorAll('body.sidebar-mini'), {});

  // Initialize bootstrap tooltips and popovers
  $('[data-toggle="tooltip"]').tooltip({
    trigger: 'hover',
  });
  $('[data-toggle="tooltip"]').on('click', function () {
    $(this).tooltip('hide');
  });
  $('[data-toggle="popover"]').popover();

  // Initialize jQuery-UI Sortable plugin (used to drag and drop items)
  $('.ui-sortable').sortable();

  // Initialize bootstrap daterangepicker with different configurations
  $('.daterange').daterangepicker({
    showDropdowns: true,
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'DD-MM-YYYY',
    },
  });
  $('.daterange_with_time').daterangepicker({
    showDropdowns: true,
    timePicker: true,
    timePickerSeconds: true,
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'DD-MM-YYYY hh:mm:ss A',
    },
  });
  $('.datepicker').daterangepicker({
    singleDatePicker: true,
    showDropdowns: true,
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'YYYY-MM-DD',
    },
  });
  $('.datepicker_with_time').daterangepicker({
    startDate: moment(),
    singleDatePicker: true,
    showDropdowns: true,
    timePicker: true,
    timePickerSeconds: true,
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'DD-MM-YYYY hh:mm:ss A',
    },
  });
  $('.predefined_daterange_with_time').daterangepicker({
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day'),
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      customRangeLabel: 'Rango personalizado',
      format: 'DD-MM-YYYY hh:mm:ss A',
    },
    showDropdowns: true,
    timePicker: true,
    timePickerSeconds: true,
    ranges: {
      Hoy: [moment().startOf('day'), moment().endOf('day')],
      Ayer: [
        moment().subtract(1, 'days').startOf('day'),
        moment().subtract(1, 'days').endOf('day'),
      ],
      'Últimos 7 días': [
        moment().subtract(6, 'days').startOf('day'),
        moment().endOf('day'),
      ],
      'Últimos 30 días': [
        moment().subtract(29, 'days').startOf('day'),
        moment().endOf('day'),
      ],
      'Este mes': [moment().startOf('month'), moment().endOf('month')],
      'Mes pasado': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
  });

  // Initialize select2
  $('select').select2({
    language: 'es',
    width: '100%',
    minimumResultsForSearch: 6,
  });
  $('.receipt_item_select, .issue_item_select').select2({
    placeholder: 'Buscar items (código o descripción)',
    minimumInputLength: 3,
  });
  $('#micro_order_workstation_select').select2({
    placeholder: 'Seleccione los números de las estaciones a utilizar',
    allowClear: true,
    language: 'es',
  });
  // Initialize doubleScroll on tables with double-scroll class
  $('.double-scroll').doubleScroll({
    resetOnWindowResize: true,
  });

  // For all file input fields, this adds the names of the chosen files as the label (placeholder) of the input field.
  $('.custom-file input').on('change', function (e) {
    const files = [];
    for (let i = 0; i < $(this)[0].files.length; i++) {
      files.push($(this)[0].files[i].name);
    }
    $(this).next('.custom-file-label').html(files.join(', '));
  });
});
